import {KeysPipe} from './pipes/keys.pipe';
import {NgModule} from '@angular/core';
import {TopBarComponent} from './components/top-bar/top-bar.component';
import {MenuLeftComponent} from './components/menu-left/menu-left.component';
import {FooterComponent} from './components/footer/footer.component';
import {BrowserModule} from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {EditGoalDialogComponent} from './components/edit-goal-dialog/edit-goal-dialog.component';
import {FormsModule} from '@angular/forms';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';
import {ChangeEventDialogComponent} from './components/dialogs/change-event-dialog/change-event-dialog.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FilterPipe} from './pipes/filter.pipe';
import { EditTeamComponent } from './components/dialogs/edit-team/edit-team.component';
import { ImageUploadModule } from 'angular2-image-upload';
import { LLSImageUploadComponent } from './components/lls-image-upload/lls-image-upload.component';
import { LLSFileDropDirective } from './components/lls-image-upload/lls-file-drop.directive';
import { UnsavedChangesDialog } from './components/dialogs/unsaved-changes-dialog/unsaved-changes-dialog';
import { SwitchEventComponent } from './components/switch-event/switch-event.component';
import {ClickOutsideModule} from 'ng-click-outside';
import { GalleryComponent } from './components/dialogs/image-modal/gallery/gallery.component';
import { UploadComponent } from './components/dialogs/image-modal/upload/upload.component';
import { ImageModalComponent } from './components/dialogs/image-modal/image-modal.component';
import {FacebookFundraiserDialogComponent} from './components/dialogs/facebook-fundraiser-dialog/facebook-fundraiser-dialog.component';
import {FacebookFundraiserSummaryDialogComponent} from './components/dialogs/facebook-fundraiser-summary-dialog/facebook-fundraiser-summary-dialog.component';
import {TotalRaisedDialogComponent} from './components/dialogs/total-raised-dialog/total-raised-dialog.component';
import {
    FacebookconfirmationDialogComponent
} from './components/dialogs/facebook-confirmation-dialog/facebook-confirmation-dialog.component';
import {FacebookFundraiserDeletionDialogComponent} from './components/dialogs/facebook-fundraiser-deletion-dialog/facebook-fundraiser-deletion-dialog.component';
import {CurrencyPipe} from '@angular/common'
import {PasswordMatcherDirective} from '../fundraising/admin-password/password-matcher.directive';
import {ChangeNationalTeamDialogComponent} from './components/dialogs/change-national-team-dialog/change-national-team-dialog.component';
import {SwitchNationalTeamComponent} from './components/switch-national-team/switch-national-team.component';
import {AppDetailsDialogComponent} from './components/dialogs/app-details-dialog/app-details-dialog.component';
import {AboutLinkComponent} from './components/about/about-link-component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'right',
    allowNegative: true,
    decimal: '.',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: ','
};

@NgModule({
    imports: [
        BrowserModule,
        RouterModule,
        CurrencyMaskModule,
        FormsModule,
        NgbModule,
        ImageUploadModule,
        ClickOutsideModule
    ],
    declarations: [
        EditGoalDialogComponent,
        ChangeEventDialogComponent,
        UnsavedChangesDialog,
        TopBarComponent,
        MenuLeftComponent,
        FooterComponent,
        KeysPipe,
        FilterPipe,
        GalleryComponent,
        UploadComponent,
        ImageModalComponent,
        EditTeamComponent,
        LLSImageUploadComponent,
        LLSFileDropDirective,
        SwitchEventComponent,
        SwitchNationalTeamComponent,
        FacebookFundraiserDialogComponent,
        FacebookFundraiserSummaryDialogComponent,
        TotalRaisedDialogComponent,
        FacebookconfirmationDialogComponent,
        FacebookFundraiserDeletionDialogComponent,
        PasswordMatcherDirective,
        ChangeNationalTeamDialogComponent,
        AppDetailsDialogComponent,
        AboutLinkComponent,
        RadioButtonComponent
    ],
    exports: [
        EditGoalDialogComponent,
        ChangeEventDialogComponent,
        UnsavedChangesDialog,
        TopBarComponent,
        MenuLeftComponent,
        FooterComponent,
        KeysPipe,
        FilterPipe,
        GalleryComponent,
        UploadComponent,
        ImageModalComponent,
        LLSImageUploadComponent,
        LLSFileDropDirective,
        PasswordMatcherDirective,
        ChangeNationalTeamDialogComponent,
        AppDetailsDialogComponent,
        AboutLinkComponent,
        RadioButtonComponent
    ],
    providers: [
        CurrencyPipe,
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class CoreModule { }
